module.exports = __webpack_public_path__ + "img/tip.28333ddf.png";